import "./stylesheets/fonts.css";
import "./stylesheets/reset.css";
import "./stylesheets/startup-error.css";
import "./stylesheets/theme.css";

import { bootstrap } from "./bootstrap";

void bootstrap({
  renderApp: () => void import("./init"),
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  root: document.querySelector("#root")!,
});
